import { useCallback, type KeyboardEvent, type RefObject } from 'react';
import { trapTab } from '@platform/ui/focusTrap';

const ITEMS = '[data-nav-item], .am-card__link';

/**
 * Клавіатура навігатора модулів (patterns/keyboard): Esc — закрити; у полі пошуку Enter — перший збіг, ↓ — до першої плитки; на плитках
 * і чипах ↑ ↓ ← → — попередня / наступна (з першої ↑ — назад у поле); Tab не виходить за межі діалогу.
 */
export function useNavigatorKeys(box: RefObject<HTMLDivElement | null>, input: RefObject<HTMLInputElement | null>, onClose: () => void, openFirst: () => void) {
  return useCallback((e: KeyboardEvent<HTMLDivElement>) => {
    const root = box.current;
    if (!root) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); onClose(); return; }
    if (e.key === 'Tab') { trapTab(root, e.nativeEvent); return; }
    const items = Array.from(root.querySelectorAll<HTMLElement>(ITEMS));
    const at = items.indexOf(document.activeElement as HTMLElement);
    if (document.activeElement === input.current) {
      if (e.key === 'Enter') { e.preventDefault(); openFirst(); }
      else if (e.key === 'ArrowDown' && items[0]) { e.preventDefault(); items[0].focus(); }
      return;
    }
    if (at < 0) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); items[Math.min(at + 1, items.length - 1)]?.focus(); }
    else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); (at === 0 ? input.current : items[at - 1])?.focus(); }
  }, [box, input, onClose, openFirst]);
}
